import React, { useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import Resumelist from "../ResumeList/Resumelist";
import Modal from "react-bootstrap/Modal";
import "./Picktemplate.scss";
import {
  templateGetParticularActions,
  templateCountAdd,
} from "../../Store/Actions/TemplateActions";
import {
  resumeEditActions,
  sampleResumeById,
} from "../../Store/Actions/ResumeActions";
import TemplateListContainer from "./TemplateListContainer";
import { useParams } from "react-router";
import { TemplateContext } from "../../Context/templateContext";
import { useHistory } from "react-router";
import { userTypeContext } from "../../Context/FreeOrProContext";
import { style } from "../../masterData";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import LoginPopup from "../Modals/LoginPopup/LoginPopup";
import { changeLayout } from "../../Store/Actions/LayoutActions";
import { EDITOR_DATA_ADD } from "../../Store/Constants/EditorConstants";
import Visualeditor from "../../Components/Visualeditor/Visualeditor";
import { HexColorPicker } from "react-colorful";
import OutsideClickHandler from "react-outside-click-handler";
import { ToastContainer, toast } from "react-toastify";

function Picktemplate(props) {
  const { id } = useParams();
  const history = useHistory();
  const path = window.location.pathname;
  const [templateId, setTemplateId] = useState(
    process.env.REACT_APP_DEFAULT_TEMPLATE_CODE
  );
  const dispatch = useDispatch();
  const [showOverlay, setShowOverlay] = useState(true);
  const [showLogin, setShowLogin] = useState(false);

  const [changeId, setChangeId] = useState(
    process.env.REACT_APP_DEFAULT_TEMPLATE_CODE
  );
  const [resumeData, setResumeData] = useState("");
  const [allTitle, setAllTitle] = useState("");
  const [paidTitle, setPaidTitle] = useState("");
  const [getTemplateData, setGetTemplateData] = useState("");
  const resume = useSelector((state) => state.resumeGetById);
  const [image, setImage] = useState("");
  const [customization, setCustomization] = useState(style);
  const [total, setTotal] = useState("");
  const [customOpen, setCustomOpen] = useState(false);
  const [current, setCurrent] = useState(0);
  const [particularData, setParticularData] = useState("");
  const getData = useSelector((state) => state.templateList.list);
  const editorData = useSelector((state) => state.editorData);
  const templateData = useSelector((state) => state.TemplateParticular.data);
  const [tempData, setTempData] = useState("");

  const { userType, setUserType } = useContext(userTypeContext);
  //Template Popup
  const { showTemplate, setShowTemplate } = useContext(TemplateContext);

  useEffect(() => {
    if (getData && getData.data && getData.data.data) {
      let template_Array = [];
      getData &&
        getData.data &&
        getData.data.data
          .filter((data) => data.status == "1")
          .map((res, index) => {
            if (index == 0) {
              setParticularData(res);
            }
            template_Array.push(res);
          });
      setGetTemplateData(template_Array);
      setTotal(template_Array.length);
    } else {
      let template_Array = [];
      getData &&
        getData.data &&
        getData.data
          .filter((data) => data.status == "1")
          .map((res, index) => {
            if (index == 0) {
              setParticularData(res);
            }
            template_Array.push(res);
          });
      setGetTemplateData(template_Array);
      setTotal(template_Array.length);
      //   getData && getData && setGetTemplateData(getData.data);
      //   setTotal(getData && getData.data && getData.data.length);
      //   setParticularData(getData && getData.data && getData.data[0]);
    }
    // setCurrent();
  }, [getData, resumeData]);

  useEffect(() => {
    let image;
    getTemplateData &&
      getTemplateData
        .filter((data) => data.template_code == templateId)
        .map((maping, index) => {
          image = JSON.parse(maping.image);
          setParticularData(maping);
          setImage(image.key);
        });
  }, [props]);

  useEffect(() => {
    setResumeData(resume);
  }, [resume]);

  const changeTemplate = (responseId, customization, type, templateData) => {
    setChangeId(responseId);
    setCustomization(customization);
    setParticularData(templateData);
    setTemplateId(templateData?.id);
    sampleSet(responseId, customization, type, templateData);
  };

  useEffect(() => {
    {
      setAllTitle(
        "All (" +
          `${
            getTemplateData &&
            getTemplateData.filter((data) => data.status == "1").length
          }` +
          ")"
      );
      setPaidTitle(
        "Premium Templates (" +
          `${
            getTemplateData &&
            getTemplateData
              .filter((data) => data.usage == "2")
              .filter((data) => data.status == "1").length
          }` +
          ")"
      );
    }
  }, [getTemplateData]);

  const sampleSet = (responseId, customization, type, templateData) => {
    //Use particularData if show only template image instead of templateData
    if (path && path.includes("create")) {
      dispatch(templateGetParticularActions(templateData?.template_code));

      let cont = templateData;
      let data = { ...props.resumeFields };
      {
        Object.keys(data && data.sectionPosition).map((keyName, i) => {
          if (keyName == "lsbar" || keyName == "rsbar") {
            data &&
              data.sectionPosition &&
              data.sectionPosition[keyName] &&
              data.sectionPosition[keyName].map((data, index) => {
                let isPresentLeft =
                  cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition.lsbar.findIndex(
                    (x) => x == data
                  );
                let isPresentRight =
                  cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition.rsbar.findIndex(
                    (x) => x == data
                  );

                if (isPresentLeft == -1 && isPresentRight == -1) {
                  if (data == "profile") {
                  } else if (data == "summary") {
                  } else {
                    if (cont.settings.customization.resumeLayout == "double") {
                      cont &&
                        cont.settings &&
                        cont.settings.sectionPosition &&
                        cont.settings.sectionPosition.rsbar.push(data);
                    } else {
                      cont &&
                        cont.settings &&
                        cont.settings.sectionPosition &&
                        cont.settings.sectionPosition.lsbar.push(data);
                    }
                  }
                } else {
                }
              });
          }
        });
      }

      ["lsbar", "rsbar"].map((position, index) => {
        cont &&
          cont.settings &&
          cont.settings.sectionPosition[position].map((sect, index) => {
            let isPresentLeft =
              data &&
              data.sectionPosition &&
              data.sectionPosition.lsbar.findIndex((x) => x == sect);
            let isPresentRight =
              data &&
              data.sectionPosition &&
              data.sectionPosition.rsbar.findIndex((x) => x == sect);

            if (isPresentLeft == -1 && isPresentRight == -1) {
              if (sect == "profile") {
              } else if (sect == "summary") {
              } else {
                cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition[position].splice(index, 1);
              }
            } else {
            }
          });
      });

      data["sectionPosition"] =
        cont && cont.settings && cont.settings.sectionPosition;
      data["editorSettings"] =
        cont && cont.settings && cont.settings.editorSettings;
      data["layout"] = cont && cont.settings && cont.settings.layout;
      dispatch(changeLayout(cont && cont.settings && cont.settings.layout));

      //for profile image show
      data["profile"]["data"][0]["showFields"]["photo"] =
        cont?.settings?.profile?.data?.[0]?.showFields?.photo;

      // For Premium Handle

      const checkLockedFeature =
        data["lockedFeatures"] === undefined ? false : true;
      if (!checkLockedFeature) {
        data["lockedFeatures"] = [];
      }
      const objWithIdIndex =
        data &&
        data["lockedFeatures"] &&
        data["lockedFeatures"].findIndex((obj) => obj === "template");
      // let res = { ...editorData }
      if (particularData && particularData.usage == "2") {
        if (objWithIdIndex === -1) {
          data["lockedFeatures"].push("template");
        }
      } else {
        if (
          data &&
          data["lockedFeatures"] &&
          data["lockedFeatures"].length > 0
        ) {
          if (objWithIdIndex > -1) {
            data &&
              data["lockedFeatures"] &&
              data["lockedFeatures"].splice(objWithIdIndex, 1);
          }
        }
      }

      data.customization = templateData?.settings.customization;
      data.template_id = templateData?.template_code;
      props.setResumeFields(data);
      dispatch({
        type: EDITOR_DATA_ADD,
        payload: data,
      });
      dispatch(sampleResumeById(id, data, "isAuth"));
    } else {
      dispatch(templateGetParticularActions(templateData?.template_code));
      dispatch(templateCountAdd(templateData?.template_code));

      let cont = templateData;
      let data = { ...props.resumeFields };
      // For pushing newly added section into template section

      {
        Object.keys(data && data.sectionPosition).map((keyName, i) => {
          if (keyName == "lsbar" || keyName == "rsbar") {
            data &&
              data.sectionPosition &&
              data.sectionPosition[keyName] &&
              data.sectionPosition[keyName].map((data, index) => {
                let isPresentLeft =
                  cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition.lsbar.findIndex(
                    (x) => x == data
                  );
                let isPresentRight =
                  cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition.rsbar.findIndex(
                    (x) => x == data
                  );

                if (isPresentLeft == -1 && isPresentRight == -1) {
                  if (data == "profile") {
                  } else if (data == "summary") {
                  } else {
                    const section = cont?.settings?.defaultPositions?.find(
                      (sec) => sec.sectionId === data
                    );
                    if (
                      section &&
                      cont &&
                      cont.settings &&
                      cont.settings.sectionPosition
                    ) {
                      const position = section.default_position; // e.g., "lsbar" or "rsbar"
                      cont.settings.sectionPosition[position]?.push(data);
                    } else {
                      if (
                        cont.settings.customization.resumeLayout == "double"
                      ) {
                        cont &&
                          cont.settings &&
                          cont.settings.sectionPosition &&
                          cont.settings.sectionPosition.rsbar.push(data);
                      } else {
                        cont &&
                          cont.settings &&
                          cont.settings.sectionPosition &&
                          cont.settings.sectionPosition.lsbar.push(data);
                      }
                    }
                  }
                } else {
                }
              });
          }
        });
      }

      ["lsbar", "rsbar"].map((position, index) => {
        cont &&
          cont.settings &&
          cont.settings.sectionPosition[position].map((sect, index) => {
            let isPresentLeft =
              data &&
              data.sectionPosition &&
              data.sectionPosition.lsbar.findIndex((x) => x == sect);
            let isPresentRight =
              data &&
              data.sectionPosition &&
              data.sectionPosition.rsbar.findIndex((x) => x == sect);

            if (isPresentLeft == -1 && isPresentRight == -1) {
              if (sect == "profile") {
              } else if (sect == "summary") {
              } else {
                cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition[position].splice(index, 1);
              }
            } else {
            }
          });
      });

      data["sectionPosition"] =
        cont && cont.settings && cont.settings.sectionPosition;
      data["editorSettings"] =
        cont && cont.settings && cont.settings.editorSettings;

      //update Layout
      let layoutArray = data["layout"];
      let movedArray = cont && cont.settings && cont.settings.layout;

      ["lsbar", "rsbar"].map((position, index) => {
        layoutArray[index].map((data) => {
          let tempData = data;
          let indexNumLeft = movedArray[0].findIndex(
            (x) => x.section == data.section
          );
          let indexNumRight = movedArray[1].findIndex(
            (x) => x.section == data.section
          );

          if (indexNumLeft == -1 && indexNumRight == -1) {
            const section = cont?.settings?.defaultPositions?.find(
              (sec) => sec.sectionId === data
            );
            if (section) {
              if (section.default_position == "lsbar") {
                movedArray[0].push(tempData);
              } else {
                movedArray[0].push(tempData);
              }
            } else {
              if (cont.settings.customization.resumeLayout == "single") {
                movedArray[0].push(tempData);
              } else {
                movedArray[1].push(tempData);
              }
            }
          } else {
            let itemIndex = data.itemIndexes;
            if (indexNumLeft != -1) {
              let tempObj = movedArray[0][indexNumLeft];
              let arr = tempObj.itemIndexes;
              itemIndex &&
                itemIndex.map((data) => {
                  const index = tempObj.itemIndexes.findIndex((e) => e == data);
                  if (index === -1) {
                    arr.push(data);
                  } else {
                    arr[index] = data;
                  }
                });

              tempObj.itemIndexes = arr;
              movedArray[0].splice(indexNumLeft, 1, tempObj);
            } else {
              let tempObj = movedArray[1][indexNumRight];
              let arr = tempObj.itemIndexes;
              itemIndex &&
                itemIndex.map((data) => {
                  const index = tempObj.itemIndexes.findIndex((e) => e == data);
                  if (index === -1) {
                    arr.push(data);
                  } else {
                    arr[index] = data;
                  }
                });

              tempObj.itemIndexes = arr;
              movedArray[1].splice(indexNumRight, 1, tempObj);
            }
          }
        });
      });

      data["layout"] = movedArray;
      dispatch(changeLayout(movedArray));

      const checkLockedFeature =
        data["lockedFeatures"] === undefined ? false : true;
      if (!checkLockedFeature) {
        data["lockedFeatures"] = [];
      }
      const objWithIdIndex =
        data &&
        data["lockedFeatures"] &&
        data["lockedFeatures"].findIndex((obj) => obj === "template");
      // let res = { ...editorData }
      if (templateData && templateData.usage == "2") {
        if (objWithIdIndex === -1) {
          data["lockedFeatures"].push("template");
        }
      } else {
        if (
          data &&
          data["lockedFeatures"] &&
          data["lockedFeatures"].length > 0
        ) {
          if (objWithIdIndex > -1) {
            data &&
              data["lockedFeatures"] &&
              data["lockedFeatures"].splice(objWithIdIndex, 1);
          }
        }
      }

      //for profile image show
      if (
        (!data["profile"]["data"][0]["showFields"]["photo"] &&
          data["profile"]["data"][0]["photo"] == "") ||
        data["profile"]["data"][0]["photo"] == null
      ) {
        data["profile"]["data"][0]["showFields"]["photo"] =
          cont?.settings?.profile?.data?.[0]?.showFields?.photo;
      }

      data.customization = templateData.settings.customization;
      props.setResumeFields(data);
      dispatch({
        type: EDITOR_DATA_ADD,
        payload: data,
      });
      const body = {
        title:
          resume && resume.resume && resume.resume.title
            ? resume.resume.title
            : "",
        body: "Body123",
        content: JSON.stringify(data),
        completed: false,
        isLetter:
          resume && resume.resume && resume.resume.isLetter
            ? resume.resume.isLetter
            : 0,
        type: "resume",
        template_id: templateData.template_code,
      };

      dispatch(
        resumeEditActions(
          id,
          body
          //   res.settings.customization,
          //   cont && cont.settings && cont.settings.sectionPosition,
          //   data["editorSettings"]
        )
      );
      //   setCanCalculate(true);
    }
    toast.success("Template changed!");
    //Need to enable if template modal close after change template
    // setShowTemplate(false);
  };

  const imgClick = (id) => {
    setTemplateId(id);
  };

  const sampleHide = () => {
    if (path.includes("create")) {
      history.push(`/create-resume/sample/${id}`);
    } else {
      history.push(`/resumes/${id}`);
    }
    // props.samplehide();
    setShowTemplate(false);
  };
  useEffect(() => {
    if (tempData && tempData.status && tempData.status == "2") {
      setTemplateId(process.env.REACT_APP_DEFAULT_TEMPLATE_CODE);
    } else {
      setTemplateId(
        resumeData && resumeData.resume && resumeData.resume.template_id
      );
      const index =
        getTemplateData &&
        getTemplateData.findIndex((res) => res.id === templateId);
      setCurrent(index);
    }
  }, [props]);

  useEffect(() => {
    const index =
      getTemplateData &&
      getTemplateData.findIndex((res) => res.id == templateId);
    setCurrent(index);
  }, [resumeData, templateId, getTemplateData]);

  const handlePrevious = () => {
    if (current <= 0) {
      return;
    } else {
      let next = getTemplateData[current - 1];
      setChangeId(next.id);
      setTemplateId(next.id);
      const image = JSON.parse(next.image);
      setImage(image.key);
      setCurrent(current - 1);
      setParticularData(next);
    }
  };
  const handleNext = () => {
    if (current >= total - 1) {
      return;
    } else {
      let next = getTemplateData[current + 1];
      setChangeId(next.id);
      setTemplateId(next.id);
      const image = JSON.parse(next.image);
      setImage(image.key);
      setCurrent(current + 1);
      setParticularData(next);
    }
  };

  useEffect(() => {
    setTempData(templateData);
  }, [templateData]);

  const handleHide = () => {
    setShowLogin(false);
  };

  const openCustomColorHandler = () => {
    setCustomOpen(true);
  };
  return (
    <>
      {/* <ToastContainer
        toastStyle={{
          backgroundColor: "#009c61",
          width: "203px",
          fontSize: "12px",
          minHeight: "30px",
          float: "right",
          marginTop: "15%",
        }}
        position="top-right"
        hideProgressBar
        autoClose={2000}
        draggable
      /> */}
      <Modal
        className="sample-resume-modal "
        show={showTemplate}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="sample-resume-modal-body">
          {/* <LoginPopup show={showLogin} hide={handleHide} /> */}

          <div className="d-grid template-wrapper">
            <div className="d-block d-sm-block sample_img_section">
              <div className="resumesampleheader">
                <div>
                  {getTemplateData && (
                    <TemplateListContainer
                      setImage={setImage}
                      data={getTemplateData}
                      imgClick={imgClick}
                      changeTemplate={changeTemplate}
                      usage="free"
                      templateId={templateId}
                      className="temp_view_all"
                      sampleSet={sampleSet}
                    />
                  )}
                </div>

                {/* <Tabs
                  defaultActiveKey="all"
                  transition={false}
                  id="noanim-tab-example"
                  className="picktemplate-navbar"
                >
                  <Tab
                    className="picktemplate-navbar"
                    eventKey="all"
                    title={allTitle}
                  >
                    {getTemplateData && (
                      <TemplateListContainer
                        setImage={setImage}
                        data={getTemplateData}
                        imgClick={imgClick}
                        changeTemplate={changeTemplate}
                        usage="free"
                        templateId={templateId}
                        className="temp_view_all"
                        sampleSet={sampleSet}
                      />
                    )}
                  </Tab>
                  <Tab eventKey="premium" title={paidTitle}>
                    <TemplateListContainer
                      changeTemplate={changeTemplate}
                      setImage={setImage}
                      imgClick={imgClick}
                      paidTemplate={
                        getTemplateData
                          ? getTemplateData &&
                            getTemplateData.filter((data) => data.usage == "2")
                          : ""
                      }
                      usage="2"
                      templateId={templateId}
                      sampleSet={sampleSet}
                      data={getTemplateData}
                    />
                  </Tab>
                </Tabs> */}
                <div className="close-div d-block d-sm-block d-md-none">
                  <img
                    src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
                    alt="closeicon"
                    className="sample-selected-close"
                    onClick={sampleHide}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>
            </div>

            <div className="d-none d-sm-none d-md-block ">
              <div className="sample-selected-img-div">
                <div className="sample_preview_image_picktemplate">
                  <div className=" ">
                    {image == "" ? (
                      <Skeleton
                        height="100vh"
                        containerClassName="avatar-skeleton"
                      />
                    ) : (
                      <>
                        <div className="row m-0">
                          {particularData?.settings?.customization?.bgColor &&
                            particularData?.settings?.customization?.bgColor &&
                            particularData?.settings?.customization?.bgColor.varients.map(
                              (res, index) => (
                                <div className="col-md-1 mb-2 p-0">
                                  <div
                                    className="multicircle mx-2 cursor"
                                    onClick={() => props.bgColorHandler(res)}
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      backgroundColor: "red",
                                      display: "flex",
                                      borderRadius: "50%",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "50%",
                                        height: "100%",
                                        backgroundColor: res,
                                      }}
                                    ></div>
                                    <div
                                      style={{
                                        width: "50%",
                                        height: "100%",
                                        backgroundColor: res,
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              )
                            )}
                          <div className="col-md-1 mb-2 p-0">
                            <div
                              className="multicircle mx-2 cursor custom-color-icon"
                              onClick={() => openCustomColorHandler()}
                              style={{
                                width: "30px",
                                height: "30px",
                                backgroundColor: "red",
                                display: "flex",
                                borderRadius: "50%",
                                overflow: "hidden",
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  // backgroundColor: res,
                                  background:
                                    "conic-gradient(from 135deg at 50% 50%, rgb(228, 58, 58) 0deg, rgb(224, 202, 83) 45deg, rgb(103, 199, 69) 95deg, rgb(66, 218, 163) 145deg, rgb(49, 187, 231) 190deg, rgb(56, 81, 214) 230deg, rgb(143, 0, 255) 280deg, rgb(231, 54, 160) 320deg, rgb(201, 73, 73) 360deg)",
                                }}
                              ></div>
                              {/* <div
                                style={{
                                  width: "50%",
                                  height: "100%",
                                  background:
                                    "conic-gradient(from 135deg at 50% 50%, rgb(228, 58, 58) 0deg, rgb(224, 202, 83) 45deg, rgb(103, 199, 69) 95deg, rgb(66, 218, 163) 145deg, rgb(49, 187, 231) 190deg, rgb(56, 81, 214) 230deg, rgb(143, 0, 255) 280deg, rgb(231, 54, 160) 320deg, rgb(201, 73, 73) 360deg)",
                                  // backgroundColor: res,
                                }}
                              ></div> */}
                            </div>
                          </div>
                          {customOpen && (
                            <OutsideClickHandler
                              onOutsideClick={(e, value) => {
                                const parentWithClass =
                                  e.target.closest(".customColorPicker");
                                const anotherParentWithClass =
                                  e.target.closest(".custom-color-icon");
                                if (
                                  customOpen &&
                                  parentWithClass == null &&
                                  anotherParentWithClass == null
                                ) {
                                  setCustomOpen(false);
                                } else if (
                                  customOpen &&
                                  parentWithClass != ""
                                ) {
                                  setCustomOpen(true);
                                }
                              }}
                            >
                              <div className="customColorPicker">
                                <HexColorPicker
                                  color={
                                    particularData?.settings?.customization
                                      ?.bgColor?.bgColor
                                  }
                                  onChange={(e) => props.bgColorHandler(e)}
                                  onBlur={(e) => props.resumeUpdate(e)}
                                />
                              </div>
                            </OutsideClickHandler>
                          )}
                        </div>
                        <div className="pick-editor-wrapper">
                          <Visualeditor
                            url={props.url}
                            shareShow={props.sharemodal}
                            actionToggle={props.actionToggle}
                            setActionToggle={props.toggleSidebar}
                            setShowPreview={props.setShowPreview}
                            setShowSample={props.setShowSample}
                            imgShow={props.backgroundChange}
                            sizeHandle={props.sizeHandle}
                            resumeFields={props.resumeFields}
                            resumeHandler={props.resumeHandler}
                            resumeTitleHandler={props.resumeTitleHandler}
                            resumeUpdate={props.resumeUpdate}
                            handleEditorChange={props.handleEditorChange}
                            dateHandler={props.dateHandler}
                            languageHandler={props.languageHandler}
                            addResumeField={props.addResumeField}
                            showHideElements={props.showHideElements}
                            sectionMoveUp={props.sectionMoveUp}
                            sectionMoveDown={props.sectionMoveDown}
                            deletePopupShow={props.deletePopupShow}
                            visualEditorFocus={props.visualEditorFocus}
                            setVisualEditorFocus={props.setVisualEditorFocus}
                            previewModal={true}
                            sample={true}
                            preview={true}
                            isSplit={true}
                            pickTemplate={true}
                            handleSliderChange={props.handleSliderChange}
                            handleProfileImageChange={
                              props.handleProfileImageChange
                            }
                            handleEditor={props.handleEditor}
                            skillsLevelHandler={props.skillsLevelHandler}
                            handleBorderChange={props.handleBorderChange}
                          />

                          {/* <img className=" pick_temp_img w-100 " src={image} /> */}
                        </div>
                      </>
                    )}

                    {/* <div
                      className="circle_shape_left"
                      onClick={handlePrevious}
                      style={
                        current == 0 ? { opacity: "0.2" } : { opacity: "1" }
                      }
                    >
                      <i
                        class="fa fa-chevron-left"
                        style={{ margin: "35% 33%", fontSize: "23px" }}
                        aria-hidden="true"
                      ></i>
                    </div>
                    <div
                      className="circle_shape_right"
                      onClick={handleNext}
                      style={
                        total - 1 == current
                          ? { opacity: "0.2" }
                          : { opacity: "1" }
                      }
                    >
                      <i
                        class="fa fa-chevron-right"
                        style={{ margin: "35% 43%", fontSize: "23px" }}
                        aria-hidden="true"
                      ></i>
                    </div> */}
                  </div>
                  {/* <div
                    className=" template-use-box"
                    onClick={() => sampleSet()}
                  >
                    <h5
                      className="card-title text-center "
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fas fa-check pr-3"></i>
                      Use this template
                    </h5>
                  </div> */}

                  <div className="close-div">
                    <img
                      src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
                      alt="closeicon"
                      className="sample-selected-close"
                      onClick={sampleHide}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Picktemplate;
